import { render, staticRenderFns } from "./MapSetter.vue?vue&type=template&id=2fb32aa4&"
import script from "./MapSetter.vue?vue&type=script&lang=js&"
export * from "./MapSetter.vue?vue&type=script&lang=js&"
import style0 from "./MapSetter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapSetter.vue"
export default component.exports